<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Plantillas de Comunicación</h1>
      <p class="mb-3 text-color-secondary">
        Gestiona las plantillas maestras multi-canal que se utilizarán en las estrategias de cobranza. 
        Cada plantilla puede incluir contenido para Email, SMS, WhatsApp y Llamadas telefónicas.
      </p>
    </div>
    <p-toast></p-toast>
  </div>
  
  <!-- Error State -->
  <div *ngIf="hasError" class="error-container">
    <div class="error-content">
      <i class="fa-solid fa-exclamation-triangle error-icon"></i>
      <h3>Oops! Algo salió mal</h3>
      <p>{{ errorMessage }}</p>
      <button pButton label="Reintentar" icon="pi pi-refresh" (click)="retry()"></button>
    </div>
  </div>
  
  <!-- Content -->
  <div *ngIf="!hasError" class="row">
    <div class="col-12">
      <app-main-table
        [apiService]="apiTemplatesService"
        [columns]="columns"
        [actions]="actions"
        [pluralEntityName]="'plantillas'"
        [additionalMainActions]="additionalMainActions"
        (onMainAction)="mainActions($event)"
        (onAction)="handleTableAction($event)"
      ></app-main-table>
    </div>
  </div>
</p-card>

<!-- Dialog para crear/editar plantilla -->
<p-dialog 
  [(visible)]="createEntity" 
  [style]="{ width: '90vw', maxWidth: '1600px' }" 
  [header]="action === 'CREATE' ? 'Nueva Plantilla' : 'Editar Plantilla'" 
  [modal]="true" 
  styleClass="p-fluid"
>
  <ng-template pTemplate="content">
    <app-template-form></app-template-form>
  </ng-template>
  
  <ng-template pTemplate="footer">
    <button 
      pButton 
      pRipple 
      label="Cancelar" 
      icon="pi pi-times" 
      class="p-button-text" 
      (click)="hideDialog()"
    ></button>
    <button 
      pButton 
      pRipple 
      label="Guardar" 
      icon="pi pi-check" 
      class="p-button-text" 
      (click)="saveForm()" 
      [disabled]="!templateService.entity.valid"
    ></button>
  </ng-template>
</p-dialog>

<!-- Dialog de confirmación -->
<p-confirmDialog></p-confirmDialog>
